// toDo: initiai states
function signInReducer(state = {}, action) {
  switch (action.type) {
    case 'ACC_CHECK_SUCCESS':
      let { userAccCheck = { userAccCheck: {} }, data = {} } = action;
      let newState = { ...state, ...userAccCheck, ...data };
      return newState;
      break;
    case 'SIGNIN_SUCCESS':
      let { access_token = '', validUser = false } = action;
      let newSignInState = { ...state, validUser };
      return newSignInState;
      break;
    case 'SET_NEW_PASS':
      let { status = false } = action;
      let newPwdState = { ...state, status };
      return newPwdState;
      break;
    case 'SOCIAL_AUTH':
      let { social = {} } = action;
      let signUpSocialState = { ...state, social };
      return signUpSocialState;
      break;
    case 'FB_SIGNIN':
      return action.fbSignIn;
      break;

    case 'SSO_CHECK_RESPONSE':
      let { ssoData = {} } = action;
      let newSSOState = { ...state, ssoData };
      return newSSOState;
      break;

    case 'ERR_SET_CAPTCHA':
      let { captchaData = '' } = action;
      let newCaptchaState = { ...state, captchaData };
      return newCaptchaState;
      break;
    case 'SIGNUP_SOCIAL_STATUS':
      let { socialLoginInfo = '' } = action;
      let newSignup = { ...state, socialLoginInfo };
      return newSignup;
      break;

    case 'POST_ACCOUNT_CHECK':
      return { ...state, postAccountCheckInfo: action.postAccountCheckInfo };
    case 'CAPTCHA_GENERATED':
      return {...state, ...action?.res}
    default:
      return state;
  }
}

export default signInReducer;
